import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { AuthGuardService } from './provider/auth-guard.service';
import { OrcAdvanceLedgerComponent } from './views/orc-advance-ledger/orc-advance-ledger.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'customer',
        loadChildren: () => import('./views/customer/customer.module').then(m => m.CustomerModule)
      },
      {
        path: 'instalment',
        loadChildren: () => import('./views/instalment/instalment.module').then(m => m.InstalmentModule)
      },
      {
        path: 'orc',
        loadChildren: () => import('./views/orc/orc.module').then(m => m.OrcModule)
      },
      {
        path: 'spot',
        loadChildren: () => import('./views/spot/spot.module').then(m => m.SpotModule)
      },
      {
        path: 'account',
        loadChildren: () => import('./views/account/account.module').then(m => m.AccountModule)
      },
      {
        path: 'account',
        loadChildren: () => import('./views/account/account.module').then(m => m.AccountModule)
      },
      {
        path: 'deduction',
        loadChildren: () => import('./views/deduction/deduction.module').then(m => m.DeductionModule)
      },
      {
        path: 'chain',
        loadChildren: () => import('./views/chain/chain.module').then(m => m.ChainModule)
      },
      {
        path: 'business',
        loadChildren: () => import('./views/business/business.module').then(m => m.BusinessModule)
      },
      {
        path: 'promotion',
        loadChildren: () => import('./views/promotion/promotion.module').then(m => m.PromotionModule)
      },
      {
        path: 'mfa',
        loadChildren: () => import('./views/mfa/mfa.module').then(m => m.MfaModule)
      },
      {
        path: 'club-member',
        loadChildren: () => import('./views/club-member/club-member.module').then(m => m.ClubMemberModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./views/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'sanlord',
        loadChildren: () => import('./views/sanlord/sanlord.module').then(m => m.SanlordModule)
      },
      {
        path: 'registration',
        loadChildren: () => import('./views/registration/registration.module').then(m => m.RegistrationModule)
      },
      {
        path: 'orc-advance-ledger',
        loadChildren: () => import('./views/orc-advance-ledger/orc-advance-ledger.module').then(m => m.OrcAdvanceLedgerModule)
      },
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
